export default {
  vehicleCharacteristic: {
    legalType: '',
    vehicleVariant: '',
    vehicleVersion: '',
    mark: '',
    model: '',
    manufacturerCountry: '',
    identificationMethodAnother: '',
    identificationPlace: '',


    titleCharacteristic: 'Технічні характеристики ТЗ',
    category: 'Категорія',
    generalDesignCharacteristics: 'Загальні конструктивні характеристики',
    mainSizes: 'Основні розміри',
    vehicleMasses: 'Маси ТЗ',
    wheelbase: '4. Колісна база',
    trailerMaxWeight: 'Максимальна маса причепа',
    powerTrain: 'Силова установка',
    speed: 'Швидкість',
    brakeSystem: 'Гальмівна система',
    body: 'Кузов',
    couplingDevice: 'Зчіпний пристрій',
    axesAndSuspension: 'Осі та підвіска',
    solidParts: 'Тверді частки',
    environmental: 'Екологічні показники',
    'type_I_or_ESC': '1.1 Випробовування типу I або ESC',
    'type_I_euro_5': '1.2 Випробовування типу I (Євро 5 або 6)',
    'type_ETC': '2. Випробування ETC (якщо застосовно):',
    typeInspection: 'Тип випробування',
    stationary: 'Нерухомий КТЗ',
    moving: 'Рухомий КТЗ',
    onStationaryVehicle: 'На нерухомому КТЗ',
    whileVehicleMoving: 'Під час руху КТЗ',
    noiseLevel: 'Нормативний документ, застосований під час виконання процедур затвердження типу',
    urbanCycle: 'Міський цикл',
    acceleratedUrbanCycle: 'Прискорений міський цикл',
    combinedCycle: 'Комбінований цикл',
    combinedAdjustedValue: 'Приведене, комбіноване значення',
    electricAndHybridVehicles: 'Електричні та гібридні КТЗ',
    typeCertification: '48. Вимірювання типу',
    noiseMeasurement: '46. Вимірювання шуму',
    smokeMeasurement: '49. Вимірювання димності',
    CO2Emissions: 'Викиди CO2',
    fuelConsumption: 'Витрата палива',
    combinedAdjustedEnergyUsage: 'Витрата електричної енергії (приведене, комбіноване значення)',
    drivingRange: 'Запас ходу',
    rotationFrequency: 'За частоти обертання',
    maximumPermissibleWeights: 'Максимальні технічно припустимі маси',
    CO2EmissionsFuelConsumptionEnergyUsage: 'Викиди CO2 / витрата палива / витрата електричної енергії: вказати ' +
        'нормативний документ, застосований під час виконання процедур затвердження типу',
    other: 'Інше',
    opacity: 'Димність',
    solidParticlesMass: 'Тверді частки (маса)',
    solidParticlesCount: 'Тверді частки (кількість)',
    opacityCorrectionCoefficient: '48.1. Димність (скоригований коефіцієнт поглинання)',
    axleGroups: 'Групи осей',
    axle: 'Вісь',
    registration: 'Реєстраційна',
    operational: 'Експлуатаційна',
    internationalRoadTraffic: 'Міжнародний дорожній рух',
    nationalRoadTraffic: 'Національному дорожньому русі',
    equippedWeightDistribution: 'Вісь {number}. Розподіл маси КТЗ у спорядженому стані за осями',
    weightDistributionAxis: 'Вісь {number}',
    weightDistribution: 'Технічно припустима маса на кожній осі',
    groupWeightDistribution: 'Технічно припустима маса на кожній групі осей',
    groupWeightDistributionGroup: 'Група осей {number}',
    permissibleMassesTitle: 'Реєстраційні/експлуатаційні максимально припустимі маси в національному/міжнародному' +
      ' дорожньому русі',
    axisPermissibleWeightTitle: 'Реєстраційна/експлуатаційна максимально припустима маса на кожній осі',
    axisPermissibleWeight: 'Вісь {number}',

    groupMaxWeightPermissibleTitle: 'Реєстраційна/експлуатаційна максимально припустима маса на кожній групі осей',
    groupMaxWeightPermissible: 'Група осей {number}',
    axisTrack: 'Колія осі',
    axisTrackControlled: 'Колія керуючої осі',
    wheel: 'Колесо {number}',
    axlesWithTwinWheels: 'Вісь зі здвоєними колесами',
    countSeats: 'Кількість місць для сидіння (включаючи водія)',
    countLowerTierSeats: 'Нижній ярус',
    countUpperTierSeats: 'Верхній ярус',

    axisDrivePneumaticSuspension: 'На рушійній(их) осі (осях) застосовано пневматичну підвіску або еквівалентні пристрої',
    axisPneumaticSuspension: 'На осі (осях) застосовано пневматичну підвіску або еквівалентні пристрої',
    note: 'Примітки',
    countFuelSystemTitle: 'Однопаливна/двопаливна/багатопаливна система',
    singleFuelSystem: 'Однопаливна система',
    dualFuelSystem: 'Двопаливна система',
    multiFuelSystem: 'Багатопаливна система',
    addedNewAxes: 'Нова кількість осей більша, ніж вже збережено. Нові осі будуть додані в кінець списку після збереження',
    removedAxes: 'Нова кількість осей менша, ніж вже збережено. Зайві осі будуь видалені з кінця списку після збереження',
    electricEngine: 'Електричний КТЗ',
    hybridEngine: 'Гібридний КТЗ',
    transferableNumbers: 'Передатні числа',
    transferableNumber: 'Передатне число {number}',
    row: 'Ряд {number}',
    seat: 'Сидіння {number}',
    addEnvironmental: 'Додати випробування',
    addNoiseTesting: 'Додати випробування шуму',
    addSmokeTesting: 'Додати випробування димності',
    emissionsTitle: 'Викиди забруднювальних речовин з відпрацьованими газами',
    euroCodeTitle: 'Код екологічної норми стосовно викидів забруднювальних речовин з відпрацьованими газами',
    legalActForEuroRate: 'Викиди забруднювальних речовин та димність відпрацьованих газів',
    legalActForType: 'Позначення нормативного документа, застосованого під час виконання процедур затвердження типу',

    CO: 'CO',
    THC: 'THC',
    HC: 'HC',
    NMHC: 'NMHC',
    NOx: 'NOx',
    THCNOx: 'THC + NOx',
    CH4: 'CH4',
    HCNOx: 'HC + NOx',
  },
  mainInfoForKtz: {
    title: 'Відомість сертифікату',
    identificationMethodAndPlace: 'Місце розміщення та метод закріплення обов\'язкових табличок',
    representative: 'Найменування та місцезнаходження уповноваженого представника виробника (за наявності)',
    baseCertificateType: {
      label: 'Тип базового сертифікату',
      types: {
        numberCertificateType: 'Номер сертифіката типу',
        numberCertificateCompliance: 'Номер сертифіката відповідності'
      }
    },
    basicCertificateNumber: 'Номер сертифіката',
    certificateIssueDate: 'Дата видачі сертифікату ',
    titleConversionInformation: 'Відомості щодо переобладнання',
    modificationApprovalIssuer: 'Ким видано документ щодо узгодження переобладнання',
    modificationApprovalDocumentNumber: 'Номер документу щодо узгодження переобладнання',
    modificationApprovalDate: 'Дата видачі документу узгодження переобладнання'
  }
}